export interface CourseLesson {
  name: string;
  link: string;
}

export interface Course {
  title: string;
  lessons: CourseLesson[];
}

export const CoursesMock: Course[] = [
  {
    title: 'Practicum by Yandex',
    lessons: [
      {
        name: 'React Developer',
        link: 'https://disk.yandex.ru/i/o1DRmeVlnRJDNg',
      },
    ],
  },
  {
    title: 'Free Code Camp',
    lessons: [
      {
        name: 'Front End Development Libraries',
        link: 'https://www.freecodecamp.org/certification/eugene.pokalyuk/front-end-development-libraries',
      },
      {
        name: 'Responsive Web Design',
        link: 'https://www.freecodecamp.org/certification/eugene.pokalyuk/responsive-web-design',
      },
      {
        name: 'JavaScript Algorithms and Data Structures',
        link: 'https://www.freecodecamp.org/certification/eugene.pokalyuk/javascript-algorithms-and-data-structures',
      },
    ],
  },
  {
    title: 'HTML Academy',
    lessons: [
      {
        name: 'Введение в React',
        link: 'https://htmlacademy.ru/profile/eugenepokalyuk',
      },
      {
        name: 'Старт в программировании',
        link: 'https://htmlacademy.ru/profile/eugenepokalyuk',
      },
      {
        name: 'Погружение в вёрстку',
        link: 'https://htmlacademy.ru/profile/eugenepokalyuk',
      },
      {
        name: 'Погружение в программирование на JavaScript',
        link: 'https://htmlacademy.ru/profile/eugenepokalyuk',
      },
      {
        name: 'Продвинутые техники и инструменты вёрстки',
        link: 'https://htmlacademy.ru/profile/eugenepokalyuk',
      },
      {
        name: 'Ретровёрстка',
        link: 'https://htmlacademy.ru/profile/eugenepokalyuk',
      },
      {
        name: 'Погружение в бэкенд',
        link: 'https://htmlacademy.ru/profile/eugenepokalyuk',
      },
    ],
  },
  {
    title: 'Skillbox',
    lessons: [
      {
        name: 'Веб-верстка «Базовый уровень», «Продвинутый уровень»',
        link: '#',
      },
      {
        name: 'JavaScript «Базовый уровень», «Продвинутый уровень»',
        link: '#',
      },
      { name: 'Node.js', link: '#' },
    ],
  },
];
